﻿'use strict';

angular.module('ntmApp').factory('ScenarioChangesBridge', ['Utils', function (Utils) {

    var bridge = {};

    bridge.OpenChangesList = function (scenario, scenarioScopes, forecastViewMode, onRevertChangesEvent) {

        var data = {
            scenarioName: scenario.value,
            scenarioId: scenario.id,
            scopes: scenarioScopes,
            viewMode: forecastViewMode
        };

        var popup = Utils.OpenModal('', 'ng1/src/staffForecasting/scenarioChangesList/scenarioChangesList.html', 'scenarioChangesListController', data, 'scenario-changes-list', null, true);

        popup.result.then(function (leave) {

            if (leave === 'revertChanges' && onRevertChangesEvent) {
                onRevertChangesEvent();
            }

            popup.dismiss();
        });

    };

    return bridge;
}]);